// @flow strict

import * as React from 'react'
import {
  type PropsWithChildren,
  PaidButton,
} from '@mondough/public-web-components'
import FeatureDiscoveryGrid, { type Feature } from '../FeatureDiscoveryGrid'
import PaidSectionWrapper from '../../PaidSectionWrapper'
import styles from './PaidFeatureDiscoveryGrid.module.scss'
import ViewportProvider, { useViewport } from '../../../utils/ViewportProvider'
import { mobileBreakpointNumber } from '../../../Global'
import FeatureDiscoveryAccordion from './FeatureDiscoveryAccordion'

type Props = {|
  features?: Feature[],
  flags?: { [key: string]: boolean },
|}

const PaidFeatureDiscoveryGrid = ({
  features,
  flags,
  children,
}: PropsWithChildren<Props>) => {
  const { width } = useViewport()

  return features != null ? (
    <PaidSectionWrapper contentClassName={styles.content}>
      <div className={styles.titleAndCTA}>
        <div>{children}</div>
        {flags && !flags.hideCompareAccountsButton && (
          <div>
            <PaidButton href="#bundles">Compare Accounts</PaidButton>
          </div>
        )}
      </div>

      {width != null && width <= mobileBreakpointNumber ? (
        <FeatureDiscoveryAccordion features={features} />
      ) : (
        <FeatureDiscoveryGrid
          features={features}
          classNames={{
            icon: styles.gridIcons,
            feature: styles.featureIcons,
          }}
        />
      )}
    </PaidSectionWrapper>
  ) : null
}

export default (props: PropsWithChildren<Props>) => (
  <ViewportProvider>
    <PaidFeatureDiscoveryGrid {...props} />
  </ViewportProvider>
)
